import { useMutation, useQueryClient } from '@tanstack/react-query';

import { session } from '@/shared/session/session';

import { authApi } from '../api/auth-api';

/**
 * The new session cookie belongs to the other organisation, so nothing cached from this one may
 * survive: every query but the session is dropped and /me is read again.
 */
export function useSwitchOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (organizationId: string) => authApi.switchOrganization(organizationId),
    meta: { successMessage: 'auth:organizations.switched' },
    onSuccess: async () => {
      queryClient.removeQueries({
        predicate: (query) => query.queryKey.join('/') !== session.queryKey.join('/'),
      });
      await session.refreshSession(queryClient);
    },
  });
}
